import HtmlContent from "../panel/elements/dynamic/html-content/htmlContent";

const Texts = function (props) {
    const {texts} = props;

    return texts.map((text, key) => {
        let styles = text.styles;

        if (styles && styles.backgroundImage && !styles.backgroundImage.includes('url')) {
            styles.backgroundImage = `url(${styles.backgroundImage})`;
        }

        return <p key={key} style={styles}
                  className={text.custom_classes ? text.custom_classes.join(' ') : null}>
            <strong>{text.title ? text.title : ''}</strong>
            <br/>
            {text.data && text.data.value ? <HtmlContent content={text.data.value}/> : ''}
            {text.image && text.image.original ?
                <img src={text.image.original} style={text.image.styles ? text.image.styles : {}}
                     alt={text.title}/> : ''}
        </p>
    });
}

export default Texts;